import get from 'lodash/get';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { applySessionData } from 'auth/actions/session.actions';
import { fetchTrustedDevices, deleteTrustedDevice } from 'user/actions/trusted-devices.actions';
import { fetchUserSecurityQuestions, saveUserData } from 'user/resources/user.api';
import myAccountTemplate from './my-account.html';
import emailChangeModalTpl from './views/email-change-confirm-modal.html';

const mapStateToThis = (state) => {
  const { session, trustedDevices, config } = state;
  const { id, loginAs, retailer, lastName, userClass, firstName, mobilePhone, emailAddress, contactPhone, retailerGroups } = session;
  const { uses2FA } = config;

  const user = {
    id,
    lastName,
    firstName,
    userClass,
    mobilePhone,
    contactPhone,
    retailerGroups,
    email: emailAddress,
    confirmEmail: emailAddress,
    ownerUserId: retailer.ownerId,
  };

  return {
    user,
    uses2FA,
    loginAs,
    trustedDevices,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  fetchTrustedDevices,
  deleteTrustedDevice,
  applySessionData,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'Notifications')
class MyAccountController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.saveUserData = saveUserData;
  }

  async $onInit() {
    this.DIRTY_FORM = 'myAccount';

    const [question1, question2] = await fetchUserSecurityQuestions(this.user.id);
    if (this.uses2FA) await this.fetchTrustedDevices();

    this.userModel = {
      ...this.user,
      password: null,
      securityQuestions: [
        {
          questionId: question1.questionId,
        },
        {
          questionId: question2.questionId,
        },
      ],
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async submitConfirm() {
    try {
      await this.checkIfEmailChanged();
      await this.saveUserData(this.userModel);

      const { password, confirmPassword, confirmEmail, securityQuestions, ...user } = this.userModel;
      this.setDirtyForm(this.DIRTY_FORM, false);
      this.applyUserSession(user);

      this.showSuccessNotification();
    } catch (err) {
      const error = get(err, 'data.errors[0]');
      // eslint-disable-next-line no-console
      console.error('MY_ACCOUNT:', error.code, error);
    }
  }

  applyUserSession(user) {
    const { firstName, lastName, mobilePhone, contactPhone, email: emailAddress } = user;
    const userSession = { firstName, lastName, mobilePhone, contactPhone, emailAddress };
    this.applySessionData(userSession);
  }

  showSuccessNotification() {
    this.Notifications.showAlert(
      this.gettextCatalog.getString('Success!'),
      this.gettextCatalog.getString('You have successfully updated your profile.')
    );
  }

  checkIfEmailChanged() {
    return this.user.email !== this.userModel.email
      ? this.Notifications.showComplexDialog({
          template: emailChangeModalTpl,
        }).result
      : Promise.resolve(true);
  }
}

export default class MyAccountComponent {
  constructor() {
    this.template = myAccountTemplate;
    this.controller = MyAccountController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/my-account/my-account-component.js